import { QueryClient } from '@tanstack/react-query';

export const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
